module.exports = __webpack_public_path__ + "邓维-2cee999d.png";